import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { apiCache } from '@/utils/cache';
import { logger } from '@/utils/logger';

const CacheManager: React.FC = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    const prev = prevPathname.current;
    const curr = pathname;

    if (prev === curr) return;
    prevPathname.current = curr;

    if (curr.startsWith('/shop') || curr.startsWith('/search')) {
      const before = apiCache.size;
      apiCache.invalidatePattern('getProducts');
      apiCache.invalidatePattern('getCategories');
      apiCache.invalidatePattern('getSizes');
      apiCache.invalidatePattern('getColors');
      apiCache.invalidatePattern('searchProducts');
      apiCache.invalidatePattern('getRelatedProducts');
      logger.debug('CacheManager: invalidated product cache on navigation to', {
        from: prev,
        to: curr,
        entriesRemoved: before - apiCache.size,
      });
      return;
    }

    if (curr.startsWith('/cart') || curr.startsWith('/checkout')) {
      const before = apiCache.size;
      apiCache.invalidatePattern('GET:/cart');
      apiCache.invalidatePattern('GET:/checkout');
      apiCache.invalidatePattern('getCart');
      apiCache.invalidatePattern('getOrders');
      logger.debug('CacheManager: invalidated cart cache on navigation to', {
        from: prev,
        to: curr,
        entriesRemoved: before - apiCache.size,
      });
      return;
    }

    if (curr.startsWith('/product/') && !prev.startsWith('/product/')) {
      apiCache.invalidatePattern('getRelatedProducts');
      return;
    }

    if (curr.startsWith('/orders')) {
      apiCache.invalidatePattern('getOrders');
      return;
    }

    if (curr.startsWith('/wishlist')) {
      apiCache.invalidatePattern('getWishlist');
      return;
    }
  }, [pathname]);

  return null;
};

export default CacheManager;
